module.exports = __webpack_public_path__ + "img/invisible.4c90c6b2.svg";